// Vendor imports
const classNames = require('classnames')
// Shared imports
const BemEntity = require('shared/bem')
// Client V2 common imports
const tag = require('client-v2/common/utils/hyperscript')

const bem = BemEntity('Icon')

function Icon(props) {
  return (
    tag('svg', {
      className: classNames(
        props.className,
        bem.block(props.id)
      ),
      title: props.title,
      // Accessibility
      'aria-hidden': props['aria-hidden'],
      'aria-label': props['aria-label']
    },
      tag('use', {
        xlinkHref: `#${props.id}`
      })
    )
  )
}

Icon.defaultProps = {
  'aria-hidden': true
}

if (__DEV__) {
  const PropTypes = require('prop-types')

  Icon.propTypes = {
    'aria-hidden': PropTypes.bool,
    'aria-label': PropTypes.string,
    className: PropTypes.string,
    id: PropTypes.string.isRequired,
    title: PropTypes.string
  }
}

module.exports = Icon
